import React from 'react';
import { PlusButton } from './PlusButton';
const issues = [{
  coverUrl: 'https://cdn.magicpatterns.com/uploads/2kH1hTTvZw7LkHMYFCLiHu/Rectangle_236.jpg',
  title: 'The Creator Issue',
  description: 'Q2 2026 Issue'
}, {
  coverUrl: 'https://cdn.magicpatterns.com/uploads/n7ja4j6woJL84BrEB2GuwM/Rectangle_240.jpg',
  title: 'The Best Brand Best Marketers',
  description: 'Q2 2026 Issue'
}, {
  coverUrl: 'https://cdn.magicpatterns.com/uploads/5nAVM72iSeFief2YQe7hk8/Rectangle_241.jpg',
  title: 'The 70 most Influential Leaders',
  description: 'Q2 2026 Issue'
}];
export function LatestIssues() {
  return <div className="flex flex-col w-full relative" style={{
    marginTop: '17px'
  }} data-id="element-188">
      {/* Gray background container for magazine cards */}
      <div className="flex flex-col gap-6 p-5 relative z-0" style={{
      borderRadius: '0 18.75px 0 0',
      backgroundColor: '#D9D9D9',
      paddingBottom: '60px'
    }} data-id="element-189">
        {issues.map((item, idx) => <div key={idx} className="flex flex-row gap-4 items-center cursor-pointer hover:opacity-80 transition-opacity" data-id="element-190">
            <div className="flex-shrink-0 overflow-hidden" style={{
          width: '135px',
          height: '186px',
          backgroundColor: '#ccc'
        }} data-id="element-191">
              <img src={item.coverUrl} alt={item.title} className="w-full h-full object-cover" data-id="element-192" />
            </div>
            <div className="flex flex-col" data-id="element-193">
              <h4 style={{
            color: '#090909',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '15px',
            fontWeight: 700,
            lineHeight: '100%'
          }} data-id="element-194">
                {item.title}
              </h4>
              <span className="mt-2" style={{
            color: '#6B6B6B',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '11.25px',
            fontWeight: 400,
            lineHeight: '100%'
          }} data-id="element-195">
                {item.description}
              </span>
            </div>
          </div>)}
      </div>

      {/* Plus button — overlaps both gray boxes */}
      <div className="flex justify-center relative z-10" style={{
      marginTop: '-37px',
      marginBottom: '-37px'
    }} data-id="element-196">
        <PlusButton size="lg" data-id="element-197" />
      </div>

      {/* 20px spacer between the two gray boxes */}
      <div style={{
      height: '20px'
    }} data-id="element-198" />

      {/* Latest Issues footer box — in front of plus sign */}
      <div className="flex items-center justify-center relative z-20" style={{
      borderRadius: '0 0 18.75px 18.75px',
      backgroundColor: '#D9D9D9',
      padding: '14px 16px'
    }} data-id="element-199">
        <span style={{
        color: '#000',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '18.75px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
        letterSpacing: '1.875px',
        textTransform: 'uppercase'
      }} data-id="element-200">
          Latest Issues
        </span>
      </div>
    </div>;
}